export const validPassword = new RegExp(
  `^((?=.*[0-9])(?=.*[A-Z])(?=.*[!@#$%^&*-.])).{8,50}$`
);

export const validPhone = new RegExp(`^([0|\+[0-9]{1,5})?([7-9][0-9]{9})$`);
export const validEightCharacter = new RegExp(`^(?=.).{8,50}$`);
export const validOneDot = new RegExp(`^(?=.*[!@#$%^&*-.]).{1,}$`);
export const validOneUpperCase = new RegExp(`^((?=.*[A-Z])(?=.*[a-z])).{1,}$`);
export const validNumber = new RegExp(`^((?=.*[0-9])).{1,}$`);
export const validEmail = new RegExp(
  `^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$`
);
